(() => {
  const todayInBrussels = (now = new Date()) => {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const part = type => parts.find(p => p.type === type).value;
    return `${part('year')}-${part('month')}-${part('day')}`;
  };
  const addDays = (day, count) => {
    const date = new Date(`${day}T12:00:00Z`);
    date.setUTCDate(date.getUTCDate() + count);
    return date.toISOString().slice(0, 10);
  };
  const validDay = day => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return false;
    const date = new Date(`${day}T12:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === day;
  };
  const minimumDay = now => addDays(todayInBrussels(now), 4);
  const isSeason = (item, ids) => Boolean(item.properties?._ranieri_season) || ids.includes(String(item.product_id));
  const cartProblem = (cart, ids, now) => {
    const items = cart.items.filter(item => isSeason(item, ids));
    if (!items.length) return '';
    const dates = items.map(item => item.properties?._ranieri_pickup_date || '');
    if (dates.some(day => !validDay(day) || day < minimumDay(now))) return 'invalid_date';
    if (new Set(dates).size !== 1) return 'mixed_dates';
    if (items.some(item => item.properties?.['Mode souhaité'] !== 'Retrait au salon')) return 'invalid_date';
    if (cart.items.some(item => item.properties?._ranieri_menu && (item.properties['Mode souhaité'] !== 'Retrait au salon' || item.properties['Date souhaitée'] !== dates[0]))) return 'mixed_order';
    return '';
  };
  const validQuantity = value => Number.isInteger(value) && value >= 1 && value <= 99;
  if (typeof module !== 'undefined' && module.exports) module.exports = { todayInBrussels, addDays, validDay, minimumDay, isSeason, cartProblem, validQuantity };
  if (typeof document === 'undefined') return;
  const configNode = document.getElementById('ranieri-season-order-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const ui = config.ui;
  const productIds = config.product_ids.map(String);
  const api = async (path, body) => {
    const response = await fetch(config.root + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || ui.network_error);
    return data;
  };
  const displayDate = day => new Intl.DateTimeFormat(config.locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${day}T12:00:00Z`));
  const money = amount => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(amount / 100);
  const pickupProperties = (properties, day) => ({ ...properties, 'Mode souhaité': 'Retrait au salon', 'Date de retrait': day.split('-').reverse().join('/'), _ranieri_season: 'halloween', _ranieri_pickup_date: day });
  const text = (tag, value, className) => { const node = document.createElement(tag); node.textContent = value; if (className) node.className = className; return node; };
  const setMinimum = input => { input.min = minimumDay(); };
  const dateMessage = () => ui.invalid_date.replace('[date]', displayDate(minimumDay()));

  if (!customElements.get('ranieri-season-order')) customElements.define('ranieri-season-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.catalog = [...this.querySelectorAll('[data-season-product]')].map(node => JSON.parse(node.textContent));
      this.variants = new Map();
      this.catalog.forEach(product => product.variants.forEach(variant => this.variants.set(String(variant.id), { ...variant, product: product.title, productId: product.id })));
      this.lines = new Map();
      this.day = this.querySelector('[data-season-date]');
      this.submit = this.querySelector('[data-season-transfer]');
      this.status = this.querySelector('[data-season-status]');
      this.error = this.querySelector('[data-season-error]');
      this.pendingKey = 'ranieri-season-pending-v1';
      this.storageKey = 'ranieri-season-selection-v1';
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
        (saved?.lines || []).forEach(line => { if (this.variants.get(line.id)?.available && validQuantity(line.quantity)) this.lines.set(line.id, line.quantity); });
        this.day.value = saved?.day || '';
        this.pending = Boolean(sessionStorage.getItem(this.pendingKey));
      } catch (_) { this.pending = false; }
      this.querySelectorAll('[data-season-card]').forEach(card => {
        card.querySelector('[data-season-add]').addEventListener('click', () => this.add(card), { signal });
        card.querySelector('[data-season-variant]').addEventListener('change', () => this.variantChanged(card), { signal });
        this.variantChanged(card);
      });
      this.day.addEventListener('change', () => { this.day.setCustomValidity(''); this.error.textContent = ''; this.save(); this.render(); }, { signal });
      this.day.addEventListener('focus', () => this.bounds(), { signal });
      window.addEventListener('focus', () => { this.bounds(); this.render(); }, { signal });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) { this.bounds(); this.render(); } }, { signal });
      this.submit.addEventListener('click', () => this.transfer(), { signal });
      this.bounds();
      this.render();
      if (this.pending) this.recover();
    }
    bounds() { setMinimum(this.day); this.querySelector('[data-season-minimum]').textContent = ui.first_pickup.replace('[date]', displayDate(this.day.min)); }
    variantChanged(card) {
      const variant = this.variants.get(card.querySelector('[data-season-variant]').value);
      card.querySelector('[data-season-price]').textContent = variant ? money(variant.price) : '';
      const button = card.querySelector('[data-season-add]');
      button.disabled = !variant?.available || this.busy || this.pending;
      button.textContent = variant?.available ? ui.add : ui.sold_out;
    }
    add(card) {
      if (this.busy || this.pending) return;
      const id = card.querySelector('[data-season-variant]').value;
      const quantity = Number(card.querySelector('[data-season-quantity]').value);
      if (!validQuantity(quantity) || !this.variants.get(id)?.available) { this.error.textContent = ui.quantity_error; return; }
      const next = (this.lines.get(id) || 0) + quantity;
      if (!validQuantity(next)) { this.error.textContent = ui.quantity_error; return; }
      this.lines.set(id, next);
      this.error.textContent = '';
      this.status.textContent = ui.added.replace('[product]', this.variants.get(id).product);
      this.save();
      this.render();
    }
    save() { try { sessionStorage.setItem(this.storageKey, JSON.stringify({ lines: [...this.lines].map(([id, quantity]) => ({ id, quantity })), day: this.day.value })); } catch (_) {} }
    render() {
      const container = this.querySelector('[data-season-lines]');
      container.replaceChildren();
      let count = 0, total = 0;
      for (const [id, quantity] of this.lines) {
        const variant = this.variants.get(id);
        if (!variant) continue;
        count += quantity; total += variant.price * quantity;
        const row = text('div', '', 'rs-selection-line');
        row.append(text('strong', variant.product));
        if (variant.title !== 'Default Title') row.append(text('small', variant.title));
        const controls = text('div', '', 'rs-line-controls');
        const input = document.createElement('input');
        input.type = 'number'; input.min = '1'; input.max = '99'; input.step = '1'; input.value = quantity; input.disabled = Boolean(this.busy || this.pending);
        input.setAttribute('aria-label', `${ui.quantity} — ${variant.product} — ${variant.title === 'Default Title' ? '' : variant.title}`);
        input.addEventListener('change', () => {
          const value = Number(input.value);
          if (!validQuantity(value)) { input.value = quantity; this.error.textContent = ui.quantity_error; return; }
          this.lines.set(id, value); this.save(); this.render();
        });
        const remove = text('button', ui.remove, 'rs-line-remove'); remove.type = 'button'; remove.disabled = Boolean(this.busy || this.pending);
        remove.setAttribute('aria-label', `${ui.remove} — ${variant.product}`);
        remove.addEventListener('click', () => { this.lines.delete(id); this.save(); this.render(); });
        controls.append(input, text('span', money(variant.price * quantity)), remove); row.append(controls); container.append(row);
      }
      if (!count) container.append(text('p', ui.empty_selection, 'rs-selection-empty'));
      this.querySelectorAll('[data-season-count]').forEach(node => { node.textContent = count; });
      this.querySelector('[data-season-total]').textContent = money(total);
      this.submit.disabled = !count || !validDay(this.day.value) || this.day.value < minimumDay() || this.busy || this.pending;
      this.submit.textContent = this.busy ? ui.adding : ui.transfer;
      this.day.disabled = Boolean(this.busy || this.pending);
      this.querySelectorAll('[data-season-card]').forEach(card => {
        card.querySelector('[data-season-variant]').disabled = Boolean(this.busy || this.pending);
        card.querySelector('[data-season-quantity]').disabled = Boolean(this.busy || this.pending);
        this.variantChanged(card);
      });
      this.querySelector('[data-season-cart-link]').hidden = !this.pending;
      if (this.day.value && (!validDay(this.day.value) || this.day.value < minimumDay())) this.error.textContent = dateMessage();
    }
    async recover() {
      this.error.textContent = ui.uncertain;
      try {
        const token = sessionStorage.getItem(this.pendingKey);
        const cart = await api('cart.js');
        if (cart.items.some(item => item.properties?._ranieri_season_batch === token)) { this.lines.clear(); this.save(); }
        sessionStorage.removeItem(this.pendingKey);
      } catch (_) {}
      this.render();
    }
    async transfer() {
      if (this.busy || this.pending) return;
      this.bounds(); this.error.textContent = '';
      const day = this.day.value;
      if (!validDay(day) || day < minimumDay()) { this.error.textContent = dateMessage(); this.day.focus(); return; }
      if (!this.lines.size) return;
      this.busy = true; this.render();
      let started = false;
      try {
        const cart = await api('cart.js');
        const existing = cart.items.filter(item => isSeason(item, productIds));
        if (existing.some(item => item.properties?._ranieri_pickup_date !== day)) throw new Error(ui.existing_date);
        if (cart.items.some(item => item.properties?._ranieri_menu && (item.properties['Mode souhaité'] !== 'Retrait au salon' || item.properties['Date souhaitée'] !== day))) throw new Error(ui.mixed_order);
        const batch = crypto.randomUUID();
        const items = [...this.lines].map(([id, quantity]) => {
          if (!this.variants.get(id)?.available || !validQuantity(quantity)) throw new Error(ui.quantity_error);
          return { id, quantity, properties: pickupProperties({ _ranieri_season_batch: batch }, day) };
        });
        if (day < minimumDay()) throw new Error(dateMessage());
        try { sessionStorage.setItem(this.pendingKey, batch); } catch (_) { throw new Error(ui.storage_error); }
        started = true; this.pending = true;
        await api('cart/add.js', { items });
        const confirmed = await api('cart.js');
        for (const expected of items) {
          const actual = confirmed.items.filter(item => item.properties?._ranieri_season_batch === batch && String(item.variant_id) === expected.id);
          if (actual.reduce((sum, item) => sum + item.quantity, 0) !== expected.quantity || actual.some(item => item.properties?._ranieri_pickup_date !== day)) throw new Error(ui.uncertain);
        }
        this.lines.clear(); this.save(); sessionStorage.removeItem(this.pendingKey);
        window.location.assign(config.cart);
      } catch (error) {
        this.error.textContent = started ? `${ui.uncertain} ${error.message === ui.uncertain ? '' : error.message}` : error.message;
      } finally { this.busy = false; this.render(); }
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
  });

  if (!customElements.get('ranieri-season-pickup')) customElements.define('ranieri-season-pickup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.input = this.querySelector('input');
      this.message = this.querySelector('[data-pickup-message]');
      this.button = this.querySelector('button');
      setMinimum(this.input);
      this.querySelector('[data-pickup-minimum]').textContent = ui.first_pickup.replace('[date]', displayDate(this.input.min));
      this.input.addEventListener('focus', () => setMinimum(this.input), { signal: this.abort.signal });
      this.input.addEventListener('change', () => { this.message.textContent = ui.save_date_hint; }, { signal: this.abort.signal });
      this.button.addEventListener('click', () => this.saveDate(), { signal: this.abort.signal });
    }
    async saveDate() {
      if (this.saving) return;
      setMinimum(this.input);
      const day = this.input.value;
      if (!validDay(day) || day < minimumDay()) { this.message.textContent = dateMessage(); this.input.focus(); return; }
      this.saving = true; this.button.disabled = true; this.message.textContent = ui.saving_date;
      try {
        let cart = await api('cart.js');
        if (cart.items.some(item => item.properties?._ranieri_menu && (item.properties['Mode souhaité'] !== 'Retrait au salon' || item.properties['Date souhaitée'] !== day))) throw new Error(ui.mixed_order);
        const maximumUpdates = cart.items.length + 1;
        for (let attempts = 0; attempts < maximumUpdates; attempts++) {
          const item = cart.items.find(item => isSeason(item, productIds) && (item.properties?._ranieri_pickup_date !== day || item.properties?.['Mode souhaité'] !== 'Retrait au salon'));
          if (!item) break;
          cart = await api('cart/change.js', { id: item.key, quantity: item.quantity, properties: pickupProperties(item.properties, day) });
        }
        cart = await api('cart.js');
        if (cartProblem(cart, productIds)) throw new Error(ui.save_date_error);
        window.location.reload();
      } catch (error) { this.message.textContent = error.message; this.button.disabled = false; this.saving = false; }
    }
    showError(message) { this.message.textContent = message; this.scrollIntoView({ block: 'center', behavior: 'smooth' }); this.input.focus({ preventScroll: true }); }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
  });

  let checking = false;
  const checkout = async event => {
    if (!config.cart_has_season && ![...document.querySelectorAll('ranieri-season-pickup')].some(node => !node.hidden)) return;
    const control = event.type === 'submit' ? event.submitter : event.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
    if (event.type === 'submit' && control?.name !== 'checkout') return;
    if (!control) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      const cart = await api('cart.js');
      const problem = cartProblem(cart, productIds);
      const picker = [...document.querySelectorAll('ranieri-season-pickup')].find(node => !node.hidden && node.getClientRects().length);
      if (picker?.saving) throw new Error(ui.saving_date);
      const savedDay = cart.items.find(item => isSeason(item, productIds))?.properties?._ranieri_pickup_date;
      if (picker?.input.value && savedDay && picker.input.value !== savedDay) throw new Error(ui.save_date_hint);
      if (problem) throw new Error(problem === 'invalid_date' ? dateMessage() : ui[problem]);
      window.location.assign(config.root + 'checkout');
    } catch (error) {
      const picker = [...document.querySelectorAll('ranieri-season-pickup')].find(node => !node.hidden && node.getClientRects().length);
      if (picker) picker.showError(error.message);
      else if (!window.location.pathname.endsWith('/cart')) window.location.assign(config.cart);
      else { const errors = document.getElementById('cart-errors'); if (errors) errors.textContent = error.message; }
    } finally { checking = false; }
  };
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
})();
